import { axios, BaseApiUrl,BaseUrl} from '../axios_config';

//查询备货信息
export const getStockingTaskAsync = params => {
    return axios.post(`${BaseApiUrl}/ReadyforTask/GetStockingTaskAsync`, params);
};

//导出
export const exportStockingTaskOut = `${BaseApiUrl}/ReadyforTask/StockingTaskOut`;

//查询备货单明细
export const getReadyforTaskDetailAsync = params => {
    return axios.get(`${BaseApiUrl}/ReadyforTask/GetReadyforTaskDetailAsync`, { params: params });
};
//查询备货基础信息
export const getReadyforTaskBasis = params => {
    return axios.get(`${BaseApiUrl}/ReadyforTask/GetReadyforTaskBasis`, { params: params });
};

//下载打包数据
export const exportReadyforTaskPackagingOut = `${BaseApiUrl}/ReadyforTask/GetReadyforTaskPackagingOut`;

//导入打包数据
export const importReadyforTaskPackaging = `${BaseApiUrl}/ReadyforTask/ImportReadyforTaskPackaging`;

//预览照片
export const getReadyforTaskReviewImages = params => {
    return axios.get(`${BaseApiUrl}/ReadyforTask/GetReadyforTaskReviewImages`, { params: params });
};

//下载打包照片
export const importReadyforTaskReviewImages = `${BaseApiUrl}/ReadyforTask/GetReadyforTaskReviewImagesFileOut`;

//查询调拨单详情
export const getStockingTransferImages = params => {
    return axios.get(`${BaseApiUrl}/ReadyforTask/GetStockingTransferImages`, { params: params });
};
//上传箱唛图片
export const editStockingTransferImages = `${BaseApiUrl}/ReadyforTask/EditStockingTransferImages`;

//打印拣货单
export const PrintPickList = params => {
    return axios.post(`${BaseApiUrl}/ReadyforTask/PrintPickList`, params).then(res => res.data);
};
//SKU导入URL
export const AttachFileUploadURL=`${BaseApiUrl}/ReadyforTask/AttachFileUpload`;

///校验附件是否存在
export const CheckAttachFileUploadIsExist = params => {
    return axios.post(`${BaseApiUrl}/ReadyforTask/CheckAttachFileUploadIsExist`, params).then(res => res.data);
};

///获取附件列表
export const GetAttachFileList = params => {
    return axios.post(`${BaseApiUrl}/ReadyforTask/GetAttachFileList`, params).then(res => res.data);
};

//下载附件
export function DownloadTaskAttach(url,filename) {

   
    var params = {filePath:url};
 
    return axios({
        url: `${BaseApiUrl}/file/ftp/down`,
        method: "get",
        params: params,
        responseType: 'blob',
    })
        .then((res) => {
          
            var content = res.data;
            console.log(res)
            var blob = new Blob([content]);
            console.log(blob)
            let fileName = filename;
            let blobObject = new Blob([content]);
            //是IE浏览器
            if (!!window.ActiveXObject || "ActiveXObject" in window) {
                window.navigator.msSaveOrOpenBlob(blobObject, fileName);
            } else {//火狐谷歌都兼容
                //模板中要有一个预定义好的a标签
                var elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blobObject);
                elink.setAttribute('download', fileName)
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            }
 
        }).catch((err) => {
            console.error(err);
 
        });
 
 };
///删除附件
 export function DeleteTaskAttach(params) {
    return axios.post(`${BaseApiUrl}/ReadyforTask/DeleteTaskAttach`, params);
 }

 //查询运输方式
 export const getTransportType = params => {
    return axios.get(`${BaseApiUrl}/ReadyforTask/GetTransportType`, { params: params });
};


 //查询物流渠道
export const getLogisticsChannelsByChannelName = params => {
    return axios.get(`${BaseApiUrl}/ReadyforTask/GetLogisticsChannelsByChannelName`, { params: params });
};

//导出模板
export const downloadBatchBox = `${BaseUrl}/template/shipping/箱明细导入模板.xlsx`;


//查询箱明细
export const getBatchBoxDetail = params => {
    return axios.get(`${BaseApiUrl}/ReadyforTask/GetBatchBoxDetail`, { params: params });
};

//将选择的箱明细存入缓存
export const addCachingBatchBox = params => {
    return axios.post(`${BaseApiUrl}/ReadyforTask/AddCachingBatchBox`, params);
};

//查询存入缓存的箱明细
export const getCachingBatchBox = params => {
    return axios.get(`${BaseApiUrl}/ReadyforTask/GetCachingBatchBox`, { params: params });
};


//导入箱明细数据
export const importImportBatchBox = `${BaseApiUrl}/ReadyforTask/ImportBatchBox`;

//保存修改备货任务
export const addReadyforTask = params => {
    return axios.post(`${BaseApiUrl}/ReadyforTask/AddReadyforTask`, params);
};


//查询备货任务明细
export const getStockingTaskById = params => {
    return axios.get(`${BaseApiUrl}/ReadyforTask/getStockingTaskById`, { params: params });
};

//审核备货任务明细
export const examineReadyforTaskStatus = params => {
    return axios.get(`${BaseApiUrl}/ReadyforTask/ExamineReadyforTaskStatus`, { params: params });
};


//查询备货常用地址
export const getCommonAddressByOrgId = params => {
    return axios.get(`${BaseApiUrl}/ReadyforTask/GetCommonAddressByOrgId`, { params: params });
};

export const PreviewsTaskAttachPDF = params => {
    return axios.get(`${BaseApiUrl}/ReadyforTask/PreviewsTaskAttachPDF`, { params: params });
};


export const PreviewsTaskSplitPDF = params => {
    return axios.post(`${BaseApiUrl}/ReadyforTask/PreviewsTaskSplitPDF`, params).then(res => res.data);
};


//下载WMS箱唛
export const getUploadFileInfoByStockingTaskID = params => {
    return axios.get(`${BaseApiUrl}/ReadyforTask/GetUploadFileInfoByStockingTaskID`, { params: params });
};


export const GetPCPrintPdfUrl = params => {
    return axios.post(`${BaseApiUrl}/ReadyforTask/GetPCPrintPdfUrl`, params).then(res => res.data);
};

///打印校验是否审核的单据
export const CheckIsExamineTask = params => {
    return axios.post(`${BaseApiUrl}/ReadyforTask/CheckIsExamineTask`, { ...params }).then(res => res.data);
};

///校验是否完全配货
export const CheckShipIsOver = params => {
    return axios.post(`${BaseApiUrl}/ReadyforTask/CheckShipIsOver`, { ...params }).then(res => res.data);
};

///打印 修改状态为已备柜
export const UpdateTaskStatusBoxLabel = params => {
    return axios.post(`${BaseApiUrl}/ReadyforTask/UpdateTaskStatusBoxLabel`, { ...params }).then(res => res.data);
};

//箱唛打印日志
export const printLog = params => {
    return axios.get(`${BaseApiUrl}/ReadyforTask/PrintLog`, { params: params });
};

//下载PDF图片
export const downPdfFile = `${BaseApiUrl}/ReadyforTask/DownPdfFile`;

